// eslint-disable-next-line no-unused-vars
import React from 'react';

import {
  Hero,
  Grid,
  Spacer,
  RichText,
  ProductCard,
  ProductCard2,
  Section,
  Image,
  ZoomImage,
  PortalButton,
  LucideIcon,
  LinkButton,
  Slider,
} from 'Components/Templates';

export const puckConfig = {
  categories: {
    layout: {
      title: 'Layout',
      components: ['Grid', 'Slider', 'Spacer', 'RichText', 'Section', 'Image', 'ZoomImage'],
    },
    content: {
      title: 'Content',
      components: ['Hero', 'LinkButton', 'PortalButton', 'LucideIcon', 'ProductCard', 'ProductCard2'],
    },
  },
  root: {
    render: ({ children }) => (
      // eslint-disable-next-line react/jsx-first-prop-new-line
      <div style={ {
        fontFamily: '\'Work Sans\', \'Helvetica Neue\', Arial, sans-serif',
        maxWidth: '1920px',
        width: '100%',
        padding: '0 45px',
        margin: '0 auto',
      } }
      >
        {children}
      </div>
    ),
  },
  components: {
    Hero,
    Grid,
    Spacer,
    RichText,
    ProductCard,
    ProductCard2,
    Section,
    Image,
    ZoomImage,
    PortalButton,
    LucideIcon,
    LinkButton,
    Slider,
  },
};

export default puckConfig;
